import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

import { logout } from "../actions/auth"
import {
	BankAccountState,
	CorporatesState,
	getUserAllCorporates,
} from "../actions/corporates"

export interface AllBankAccountListState {
	loading: boolean
	error: undefined | AxiosError<string>
	list: BankAccountState[]
}

const initialState: AllBankAccountListState = {
	loading: false,
	error: undefined,
	list: [],
	selected: undefined,
}

const bankAccountSlice = createSlice({
	name: "bankAccounts",
	initialState: initialState,
	reducers: {
		clearError: (state: AllBankAccountListState) => {
			state.error = undefined
			state.loading = false
		},
		resetDefault: (state: AllBankAccountListState) => {
			state.loading = false
			state.loadingFetch = false
			state.error = undefined
			state.errorFetch = undefined
			state.selected = undefined
		},
		selectBankAccount: (
			state: AllBankAccountListState,
			action: PayloadAction<BankAccountState | undefined>
		) => {
			state.selected = action?.payload
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(logout.fulfilled, () => initialState)
			.addCase(
				getUserAllCorporates.pending,
				(state: AllBankAccountListState) => {
					state.loading = true
					state.error = undefined
				}
			)
			.addCase(
				getUserAllCorporates.fulfilled,
				(
					state: AllBankAccountListState,
					action: PayloadAction<CorporatesState[]>
				) => {
					state.loading = false
					state.error = undefined
					state.list = action?.payload?.flatMap(
						(corporate) => corporate.contiCorrenti
					)
				}
			)
			.addCase(
				getUserAllCorporates.rejected,
				(state: AllBankAccountListState, action) => {
					state.loading = false
					state.error = action?.payload.message
				}
			)
	},
})

export const { clearError, resetDefault, selectBankAccount } =
	bankAccountSlice.actions

export default bankAccountSlice.reducer
